export default __webpack_public_path__ + "img/moho nord.293a5a4d.jpg";